import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import Loader from './utils/Loader';
import Tooltip from './utils/Tooltip';

const Applauses = () => {

  const authState = useSelector(state => state.authReducer);
  const [applauses, setApplauses] = useState([]);
  const [fetchData, { loading }] = useFetch();

  const fetchApplauses = useCallback(() => {
    const config = { url: "/applauses", method: "get", headers: { Authorization: authState.token } };
    fetchData(config, { showSuccessToast: false }).then(data => setApplauses(data.applauses));
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchApplauses();
  }, [authState.isLoggedIn, fetchApplauses]);


  const handleDelete = (id) => {
    const config = { url: `/applauses/${id}`, method: "delete", headers: { Authorization: authState.token } };
    fetchData(config).then(() => fetchApplauses());
  }


  return (
    <>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        {applauses.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-xl'>Your Applauses ({applauses.length})</h2>}
        {loading ? (
          <Loader />
        ) : (
          <div>
            {applauses.length === 0 ? (

              <div className='w-[600px] h-[300px] flex items-center justify-center gap-4'>
                <span>No Applause found</span>
                <Link to="/applauses/add" className="bg-blue-500 text-white hover:bg-blue-600 font-medium rounded-md px-4 py-2">+ Add new Applause</Link>
              </div>

            ) : (
                applauses.map((applauses, index) => (
                <div key={applauses._id} className='bg-white my-4 p-4 text-gray-600 rounded-md shadow-md'>
                  <div className='flex'>

                    <span className='font-medium'>Applauses #{index + 1}</span>

                    <Tooltip text={"Edit this applauses"} position={"top"}>
                      <Link to={`/applauses/${applauses._id}`} className='ml-auto mr-2 text-green-600 cursor-pointer'>
                        <i className="fa-solid fa-pen"></i>
                      </Link>
                    </Tooltip>

                    <Tooltip text={"Delete this applause"} position={"top"}>
                      <span className='text-red-500 cursor-pointer' onClick={() => handleDelete(applauses._id)}>
                        <i className="fa-solid fa-trash"></i>
                      </span>
                    </Tooltip>

                  </div>
                  <div className='whitespace-pre'>{applauses.description}</div>
                </div>
              ))

            )}
          </div>
        )}
      </div>
    </>
  )

}

export default Applauses